(() => {
'use strict';
const key = 'workflow_supply_list';
const panel = document.querySelector('[data-wf-reorder]');
if (!panel) return;
const list = panel.querySelector('[data-supply-list]');
const message = panel.querySelector('[data-supply-message]');
const reorder = panel.querySelector('[data-reorder-button]');
const save = panel.querySelector('[data-save-button]');
const root = panel.dataset.root;
const allowed = [10496037290267,10496037323035,10496037388571,10496037454107,10496037519643,10498333409563];
let supplies = [];
const render = () => {
 list.replaceChildren();
 for (const item of supplies) {
  const row = document.createElement('li');
  row.textContent = item.title + ' — ' + item.variant + ' × ' + item.quantity;
  list.append(row);
 }
 reorder.disabled = !supplies.length;
 message.textContent = supplies.length ? panel.dataset.readyText : panel.dataset.emptyText;
};
try {supplies = JSON.parse(localStorage.getItem(key) || '[]'); if (!Array.isArray(supplies)) supplies=[];} catch {supplies=[];}
render();
save.addEventListener('click',async()=>{
 save.disabled=true;
 try {
  const response=await fetch(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
  if(!response.ok) throw new Error('Could not read your cart. Please try again.');
  const cart=await response.json();
  supplies=cart.items.filter(item=>allowed.includes(item.product_id)).map(item=>({id:item.variant_id,quantity:item.quantity,title:item.product_title,variant:item.variant_title,properties:item.properties}));
  if(!supplies.length) throw new Error('Add bottle packs to your cart first.');
  localStorage.setItem(key,JSON.stringify(supplies));
  render();
 } catch(error){message.textContent=error.message;} finally {save.disabled=false;}
});
reorder.addEventListener('click',async()=>{
 reorder.disabled=true;
 try {
  const items=supplies.map(item=>({id:item.id,quantity:item.quantity,properties:item.properties}));
  const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
  const result=await response.json();
  if(!response.ok) throw new Error(result.description||'Supplies could not be added. Check current availability.');
  window.location.assign(panel.dataset.cartUrl);
 } catch(error){message.textContent=error.message;reorder.disabled=false;}
});
})();